module.exports = __webpack_public_path__ + "468214b7184311fb7fa13940d745fb8c.fbx";